const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        line: null,
        mark: null
    }
});



// WEBPACK FOOTER //
// ./system/domain/entity/relation-type.js